const provenanceTypes = {
  empty: '',
  bulk: 'BULK_ACCEPT'
};

export { provenanceTypes };